import en from './locales/en.json';
import fr from './locales/fr.json';

export type Locale = 'fr' | 'en';

export const DEFAULT_LOCALE: Locale = 'en';
export const SUPPORTED_LOCALES: readonly Locale[] = ['fr', 'en'] as const;

export const messages = {
  en,
  fr
} as const;

export type MessageSchema = typeof en;
